import { ChevronLeft } from '@styled-icons/heroicons-outline/ChevronLeft';
import { ChevronRight } from '@styled-icons/heroicons-outline/ChevronRight';
import { ScrollButtonGroupSchema } from '@/views/sports/components/ScrollButtonGroup/styles/ScrollButtonGroup.styles';

export const scrollButtonGroupStyles: ScrollButtonGroupSchema = {
  iconButtonScrollRightSvg: {
    as: ChevronRight,
    sx: {
      boxSize: '3.5',
      filter: 'drop-shadow(0px 1px 0px rgba(255, 255, 255, 0.5))',
    },
  },
  iconButtonScrollRight: {
    bgGradient: 'linear(to-b, gamma.200, gamma.400)',
    color: 'blackAlpha.800',
    border: 'none',
    h: 9,
    w: 4,
    boxShadow:
      '0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(255, 255, 255, 0.2) inset',
    _hover: {
      color: 'blackAlpha.800',
    },
    _active: {
      '&:after': {
        backgroundImage: 'none',
      },
    },
  },
  iconButtonScrollLeftSvg: {
    as: ChevronLeft,
    sx: {
      boxSize: '3.5',
      filter: 'drop-shadow(0px 1px 0px rgba(255, 255, 255, 0.5))',
    },
  },
  iconButtonScrollLeft: {
    bgGradient: 'linear(to-b, gamma.200, gamma.400)',
    color: 'blackAlpha.800',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.5)',
    border: 'none',
    h: 9,
    w: 4,
    boxShadow:
      '0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(255, 255, 255, 0.2) inset',
    _hover: {
      color: 'blackAlpha.800',
    },
    _active: {
      '&:after': {
        backgroundImage: 'none',
      },
    },
  },
  flexWrapper: {
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.10), 0px 3px 5px 0px rgba(0, 0, 0, 0.20) inset',
  },
  buttonGroupSports: {
    bg: 'blackAlpha.400',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 3px 5px 0px rgba(0, 0, 0, 0.2) inset',
    borderRadius: [null, null, 'base'],
    display: 'inline-flex',
    flex: '1',
    overflowX: 'auto',
    pl: '1',
    py: '1',
    h: '9',
    mt: '0.5',
    spacing: '1',
    whiteSpace: 'nowrap',
    sx: { '::-webkit-scrollbar': { display: 'none' } },
  },
  buttonGroupScrolls: {
    display: ['none', null, null, 'inline-flex'],
    pos: 'relative',
    ml: 'auto',
    gap: 1,
    pl: 1,
    pt: 0.5,
    isAttached: true,
  },
  scrollIndicator: {
    pos: 'absolute',
  },
};
